import axios from 'axios';
import { getCookie, setCookie } from '../cookie/cookie';
import tippy from 'tippy.js';

/**
 * AjaxForm
 * A plugin that add ajax-request to forms.
 * @version 0.1.0
 * @exports EduCart
 */
export default class EduCart {
    /**
     * 
     * @param {any} navElement
     * @public
     */
    constructor(navElement) {
        if (!navElement) {
            return;
        }

        const menuId = navElement.getAttribute('aria-controls');
        if (!menuId) {
            return;
        }

        const menuElement = document.getElementById(menuId);
        if (!menuElement) {
            return;
        }

        this.cartNav = navElement;
        this.badge = this.cartNav.querySelector('.badge');
        this.updateActionUrl = this.cartNav.getAttribute('data-update-action') || '/cart/update';
        this.mailActionUrl = this.cartNav.getAttribute('data-mail-action') || '/cart/mail';
        this.printActionUrl = this.cartNav.getAttribute('data-print-action') || '/cart/print';

        this.cartSideMenu = menuElement;
        this.closeButton = this.cartSideMenu.querySelector('.cart-close');

        this.addButton = document.getElementById('cartAddButton');

        this.count = 0;
        this.resetFormOnClose = false;

        this._init();
    }

    static COOKIE_NAME = 'CartItems';

    /**
     * 
     * */
    _init() {
        this._updateBadge();

        /* kundkorg */
        this.cartNav.addEventListener('click', () => {
            const expanded = this.cartSideMenu.classList.toggle('open');
            this.cartNav.setAttribute('aria-expanded', expanded);
        });

        const menuChildSelector = '#' + this.cartSideMenu.id + ' *';

        /* st�ng kundvagn vid klick utanf�r */
        document.addEventListener('click', event => {
            if (this.cartSideMenu.classList.contains('open') && !event.target.matches(menuChildSelector)) {
                event.stopPropagation();
                this._close();
            }
        }, true); /* true: stoppa eventet direkt i bubbelfasen f�r att inte r�ka trigga n�got annat i dokumentet */

        this.cartSideMenu.addEventListener('click', event => {
            if (!event.target.matches('button, button *')) {
                return;
            }

            const target = event.target;

            /* st�ng kundvagn */
            if (target.classList.contains('cart-close')) {
                this._close();
                return;
            }

            /* skriv ut -- inaktiverad */
            //if (target.classList.contains('cart-print')) {
            //    this._print();
            //    return;
            //}

            /* ta bort utbildning */
            if (target.classList.contains('cart-item--remove')) {
                const item = target.closest('.cart-item');
                const id = item && item.getAttribute('data-item-id');
                if (id) {
                    this._toggleItem(id, 'remove')
                        .then(() => this.addButton && this.addButton.getAttribute('data-cart-item-id') === id && this._toggleAddButton(false));
                }
                return;
            }

            /* �ppna mejlmeny */
            if (target.classList.contains('cart-send')) {
                const id = target.getAttribute('aria-controls');
                const menu = id && document.getElementById(id);
                menu && this._openSubmenu(menu);
                return;
            }

            /* st�ng submeny */
            if (target.classList.contains('submenu-close')) {
                const id = target.getAttribute('aria-controls');
                const submenu = id && document.getElementById(id);
                submenu && this._toggleSubmenu(submenu, false);
                return;
            }
        });

        /* spara-knapp */
        if (this.addButton) {
            const id = this.addButton.getAttribute('data-cart-item-id');
            const itemSelector = `.cart-item[data-item-id="${id}"]`;

            this._toggleAddButton(this.cartSideMenu.querySelector(itemSelector) !== null);

            this.addButton.addEventListener('click', () => {
                const action = this.cartSideMenu.querySelector(itemSelector) === null ? 'add' : 'remove';
                this._toggleItem(id, action)
                    .then(() => this._toggleAddButton(this.cartSideMenu.querySelector(itemSelector) !== null));
            });
        }

        /* event n�r mejlformul�r blivit inskickat */
        this.cartSideMenu.addEventListener('epiformsubmitted', () => {
            setCookie(EduCart.COOKIE_NAME, '', -2, '/');
            this.addButton && this.addButton.classList.remove('in-cart');
            this._updateCart();
            this.resetFormOnClose = true;
        });
    }

    /**
     * 
     * @param {any} id
     * @param {any} action
     */
    _toggleItem(id, action) {
        let value = getCookie(EduCart.COOKIE_NAME);
        const items = value.split('|');
        const index = items.indexOf(id);

        switch (action) {
            case 'add':
                if (index > -1) {
                    return Promise.resolve();
                }
                items.push(id);
                break;
            case 'remove':
                if (index === -1) {
                    return Promise.resolve();
                }
                items.splice(index, 1);
                break;
        }

        value = items.join('|');
        setCookie(EduCart.COOKIE_NAME, value, !value ? -2 : 1, '/');

        return this._updateCart();
    }

    /**
     * 
     * */
    _updateCart() {
        return axios({
            method: 'get',
            url: '/cart/update'
        }).then(resp => {
            if (resp.status === 200) {
                this.cartSideMenu.querySelector('.menu--cart .cart-items').innerHTML = resp.data;
            }
        }).finally(() => this._updateBadge());
    }

    /**
     * 
     * @param {any} state
     */
    _toggleAddButton(state) {
        if (!this.addButton) {
            return;
        }

        this.addButton.classList.toggle('in-cart', state);
        const tooltip = this.addButton.getAttribute('data-tooltip-' + (state ? 'remove' : 'add'));
        this.addButton._tippy && this.addButton._tippy.setContent(tooltip);
    }

    /**
     * 
     * */
    _updateBadge() {
        this.count = this.cartSideMenu.querySelectorAll('.cart-items .cart-item').length;
        this.badge.innerText = this.count;
        this.cartNav.toggleAttribute('hidden', this.count === 0);
    }

    /**
     * 
     * */
    _close() {
        this.cartSideMenu.classList.remove('open');
        this.cartNav.setAttribute('aria-expanded', false);
        /* st�ng alla ev submenyer */
        for (const node of this.cartSideMenu.querySelectorAll('.submenu')) {
            this._toggleSubmenu(node, false);
        }
    }

    /**
     * 
     * @param {Element} e
     */
    _openSubmenu(e) {
        if (!e) {
            return;
        }

        const formlist = e.querySelector('.form__item--cart-items');

        if (formlist) {
            const ol = formlist.querySelector('ol');
            const templ = formlist.querySelector('template');

            if (!(ol && templ)) {
                return;
            }

            //let html = '';
            ol.innerHTML = '';

            for (const item of this.cartSideMenu.querySelectorAll('.menu--cart .cart-item')) {
                const li = templ.content.cloneNode(true);
                li.querySelector('span').innerText = item.querySelector('.cart-item--name').innerText;
                li.querySelector('input').setAttribute('value', item.getAttribute('data-item-id'));
                ol.append(li);
            }
        }

        this._toggleSubmenu(e, true);

        e.classList.add('open');
        e.id && this.cartSideMenu.querySelectorAll(`[aria-controls="${e.id}"]`).forEach(e => e.setAttribute('aria-expanded', true));
    }

    /**
     * �ppnar eller st�nger submeny, och s�tter tillh�rande aria-expanded
     * @param {any} submenu
     * @param {any} opening
     */
    _toggleSubmenu(submenu, opening) {
        submenu.classList.toggle('open', opening);

        if (submenu.id) {
            for (const node of this.cartSideMenu.querySelectorAll(`[aria-controls="${submenu.id}"]`)) {
                node.setAttribute('aria-expanded', opening);
            }
            if (submenu.id === 'cartMailMenu') {
                if (!opening && this.resetFormOnClose) {
                    submenu.querySelector('form').reset();
                    this.resetFormOnClose = false;
                }
            }
        }
    }

    /**
     * 
     * */
    _print() {
        /* Renderar en osynlig iframe vars inneh�ll skrivs ut, och som tas bort efter�t */
        const prfr = document.createElement('iframe');
        prfr.id = 'printing-iframe';
        prfr.style.position = 'fixed';
        prfr.style.right = prfr.style.bottom = prfr.style.width = prfr.style.height = prfr.style.border = 0;

        prfr.src = this.printActionUrl;

        prfr.onload = function () {
            const cw = prfr.contentWindow;
            cw.onbeforeunload = cw.onafterprint = () => prfr && prfr.remove();
            cw.focus();
            cw.print();
        };

        document.body.append(prfr);
    }
}
